import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import { CancelRounded } from "@material-ui/icons";

import searchInputIcon from "../../../../assets/images/search-input-icon.svg";
import { useDebounce } from "../AppLayout/components/AppToolBar/components/useDebounce";
import { rSetPageSearchText } from "../../../../store/actions/properties";

const PageSearchBar = ({ show, pageTitle, headerTitle }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { pageSearchText } = useSelector(({ reducers }) => reducers);
  const [search, setSearch] = useState(pageSearchText);
  const debouncedSearch = useDebounce(search, 1000);

  useEffect(() => {
    dispatch(rSetPageSearchText(""));
  }, [location]);

  useEffect(() => {
    dispatch(rSetPageSearchText(debouncedSearch));
  }, [debouncedSearch]);

  return show ? (
    <div className="app-search-bar">
      <img src={searchInputIcon} alt="search" />
      <TextField
        name="app-search-text"
        variant="outlined"
        placeholder={`Search ${(pageTitle || headerTitle)?.toLowerCase()}...`}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ flex: 1 }}
        autoComplete="off"
        autoCorrect="off"
        inputProps={{
          autoComplete: "new-password",
          form: {
            autoComplete: "off",
          },
        }}
      />
      {!!search && (
        <CancelRounded
          data-testid="search-cancel-text-icon"
          onClick={() => setSearch("")}
          style={{ color: "#999", cursor: "pointer" }}
        />
      )}
    </div>
  ) : null;
};

export default PageSearchBar;
